export interface PermissionPeoplePresentation<TOwner, TUser> {
  owner: TOwner | null;
  visibleNonOwners: TUser[];
  showOwnerDivider: boolean;
}

export type GrantedUsersPaginationAction = 'load-more' | 'ready' | 'wait';

export function resolveGrantedUsersPaginationAction({
  error,
  hasMore,
  isLoading,
  loadedCount,
  requestStartCount,
}: {
  error: boolean;
  hasMore: boolean;
  isLoading: boolean;
  loadedCount: number;
  requestStartCount: number | null;
}): GrantedUsersPaginationAction {
  if (error) return 'ready';
  if (isLoading) return 'wait';
  if (!hasMore) return 'ready';
  if (requestStartCount === null || loadedCount > requestStartCount) {
    return 'load-more';
  }
  return 'wait';
}

export function resolvePermissionPeoplePresentation<TOwner, TUser>({
  owner,
  users,
  getOwnerId,
  getUserId,
  isOwnerUser,
  isUserVisible,
}: {
  owner: TOwner | null;
  users: readonly TUser[];
  getOwnerId: (owner: TOwner) => string;
  getUserId: (user: TUser) => string;
  isOwnerUser: (user: TUser) => boolean;
  isUserVisible: (user: TUser) => boolean;
}): PermissionPeoplePresentation<TOwner, TUser> {
  const ownerId = owner ? getOwnerId(owner) : null;
  const visibleNonOwners = users.filter(
    user =>
      !isOwnerUser(user) &&
      (ownerId === null || getUserId(user) !== ownerId) &&
      isUserVisible(user)
  );

  return {
    owner,
    visibleNonOwners,
    showOwnerDivider: owner !== null && visibleNonOwners.length > 0,
  };
}
